module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/box-2-451e0252c1d417a50e86dee66cd4e92f.svg";